module.exports = __webpack_public_path__ + "static/img/DMC.20fbe0a8.png";